import {useContext, useState} from "react";
import {shareMarketplaceAPI} from "../common/api/shareMarketplaceAPI";
import {createURLQueryFromParams} from "../common/api/apiUtil";
import {useKeycloakFunctions} from "./useKeycloakFunctions";
import {API_SHARE_MARKETPLACE_OFFERS, API_SHARE_MARKETPLACE_OFFERS_DEACTIVATION} from "../common/api/apiConstants";
import {LocaleContext} from "../store/providers/LocaleProvider";

export const useMarketplaceOfferDeactivation = () => {

    const {initialized, authenticated} = useKeycloakFunctions();
    const {localeUppercaseUnderscore} = useContext(LocaleContext)[0];

    const [offerDeactivation, setOfferDeactivation] = useState(undefined);
    const [loadingOfferDeactivation, setLoadingOfferDeactivation] = useState(false);
    const [errorOfferDeactivation, setErrorOfferDeactivation] = useState(null);

    const deactivateOffer = (offerId) => {

        if (offerId && initialized && authenticated) {
            setLoadingOfferDeactivation(true);

            let params = {};
            params.locale = localeUppercaseUnderscore || "en_GB";

            shareMarketplaceAPI.post(API_SHARE_MARKETPLACE_OFFERS
                + "/" + offerId + API_SHARE_MARKETPLACE_OFFERS_DEACTIVATION
                + createURLQueryFromParams(params))
                .then(res => res.data)
                .then(() => {
                    setLoadingOfferDeactivation(false);
                    setOfferDeactivation(true);
                })
                .catch(err => {
                    setLoadingOfferDeactivation(false);
                    setErrorOfferDeactivation(err);
                });
        }
    };

    return {
        deactivateOffer,
        offerDeactivation,
        loadingOfferDeactivation,
        errorOfferDeactivation,
        setErrorOfferDeactivation
    };
};
